import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface User {
  email: string;
  role: 'admin' | 'manager' | 'exclusive' | 'USER' | 'DEALER';
  name: string;
  id?: string | number;
}

interface AuthState {
  user: User | null;
  token: string | null;
}

const initialState: AuthState = {
  user: null,
  token: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action: PayloadAction<{ user: User; token: string }>) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
      localStorage.setItem('diasporawise_admin_token', action.payload.token);
      localStorage.setItem('diasporawise_admin_user', JSON.stringify(action.payload.user));
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
      localStorage.removeItem('diasporawise_admin_token');
      localStorage.removeItem('diasporawise_admin_user');
    },
    restoreAuth: (state) => {
      const token = localStorage.getItem('diasporawise_admin_token');
      const user = localStorage.getItem('diasporawise_admin_user');
      if (token && user) {
        state.token = token;
        state.user = JSON.parse(user);
      }
    },
  },
});

export const { login, logout, restoreAuth } = authSlice.actions;
export default authSlice.reducer;